// @flow
import initialState from "./initialState";
import * as ActionTypes from "../actions/actionTypes";
import { EntityList, Product } from "../flow/types";

export default function(
  state: EntityList<Product> = initialState.products,
  action: any
) {
  switch (action.type) {
    case ActionTypes.GET_PRODUCTS + ActionTypes.FULFILLED:
      // var newState =  {products: action.payload.data};
      var data = action.payload.data;
      const result: EntityList<Product> = new EntityList(
        data.result,
        data.totalPages,
          data.totalRecords
      );
      return result;
    default:
      return state;
  }
}
